import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { storeActions } from '@src/ducks';
import { fetchStaticFooter } from '@src/requests/fetchStaticFooter';
import { getStaticFooterContent, isStaticFooterLoading } from '@src/selectors/staticFooter';
import { unique } from '@src/utils/componentHelpers';

const useStaticFooter = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        const fetch = unique();

        dispatch(storeActions.appRequest(fetchStaticFooter(fetch)));
    }, [dispatch]);

    const isLoading = useSelector(isStaticFooterLoading);
    const content = useSelector(getStaticFooterContent);

    return [isLoading, content];
};

export { useStaticFooter };
